<div
  class="categories row header-msg"
  [style.background-color]="backgroundColor">
  <p [style.color]="textColor">
    {{ text }}
  </p>
</div>
